import React, {Component} from 'react';
import ExpansionPanel from "@material-ui/core/es/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/es/ExpansionPanelSummary";
import Typography from "@material-ui/core/es/Typography";
import Hidden from "@material-ui/core/Hidden";
import Fade from "@material-ui/core/es/Fade";
import ExpansionPanelDetails from "@material-ui/core/es/ExpansionPanelDetails";
import Grid from "@material-ui/core/es/Grid";
import Button from "@material-ui/core/es/Button";
import * as Optional from "optional-js";
import {MdExpandMore} from "react-icons/md";
import LabelAndText from "../../../components/common/LabelAndText";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {cancelRemoveAccountFromDevice, removeAccountFromDevice, setCommand} from "../DevicesActions";
import {openConfirmationModal} from "../../../components/confirmation-modal/ConfirmationModalActions";

class DeviceExpPanel extends Component {

    getOptionalDateFormatted(optional) {
        return optional.map(time => this.getDateFormated(time)).orElse("Unknown");
    }

    getDateFormated(time) {
        const date = new Date(time);
        return date.toLocaleString();
    }

    removeOrCancel = isCancellation => {
        const {openConfirmationModal, setCommand, brand, user: {email}, device: {vendor_id: vendorId, device_id: deviceId, d_model}} = this.props;
        const command = 'remote_wipe';
        const status = isCancellation ? 4 : null;
        const callback = () => setCommand({email, vendorId, deviceId, status, command});
        if(isCancellation){
            return callback()
        }
        openConfirmationModal({text: `Are you sure you want to remove this account from ${d_model}?`, callback})
    };

    render() {
        const {device, classes, isOpened, handleListItemClick, index} = this.props;
        const parsedLastSeen = this.getOptionalDateFormatted(Optional.ofNullable(device.last_seen).map(last_seen => parseFloat(last_seen)));
        const removeSent = device.commands.reduce((acc, item) => acc || (item.command === 'remote_wipe' && item.status === 1), false);
        return (
            <ExpansionPanel expanded={isOpened}
                            onChange={() => handleListItemClick(index)}>
                <ExpansionPanelSummary expandIcon={<MdExpandMore/>}>
                    <Typography className={classes.heading}>{device.d_model}</Typography>
                    <Hidden xsDown>
                        <Fade in={!isOpened}>
                            <Typography className={classes.secondaryHeading}>
                                {parsedLastSeen}
                            </Typography>
                        </Fade>
                    </Hidden>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Grid container justify='center' style={{opacity: isOpened ? 1 : 0}}>
                        <Grid item xs={12} style={{backgroundColor: 'white'}}>
                            <LabelAndText label="Last Seen" content={parsedLastSeen}/>
                            {/*{this.renderLabelContentRow("Created At", this.getDateFormated(device.created_at))}*/}
                            {/* <LabelAndText label="Remote Access"
                                          content={!removeSent ?
                                              <Button variant="raised" color="secondary" onClick={() => this.removeOrCancel(false)}>
                                                  Remove account
                                              </Button> :
                                              <Button variant="raised" onClick={() => this.removeOrCancel(true)}>
                                                  Cancel Remove account
                                              </Button>}/> */}
                        </Grid>
                    </Grid>
                </ExpansionPanelDetails>
            </ExpansionPanel>
        )
    }

}

function mapStateToProps({user, brand}) {
    return ({user, brand})
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setCommand,
        openConfirmationModal
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(DeviceExpPanel);



// WEBPACK FOOTER //
// ./src/containers/devices/component/DeviceExpPanel.js